import React, { useState, useEffect } from "react";
import "./Carousel.css";

import Modelo1 from "./images/modelo1.png";
import Modelo2 from "./images/modelo2.png";
import Modelo3 from "./images/modelo3.png";

const images = [
    { id: 1, src: Modelo1, alt: "@drapatriciaandrade" },
    { id: 2, src: Modelo2, alt: "@rhainarafisioterapeuta" },
    { id: 3, src: Modelo3, alt: "@laguspastelaria" },
];

const Carousel: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [tiltEffect, setTiltEffect] = useState({ rotateX: 0, rotateY: 0 });
    const [isFlipping, setIsFlipping] = useState(false);
    const [flipDirection, setFlipDirection] = useState(1);
    const intervalRef = React.useRef<NodeJS.Timeout | null>(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIfMobile = () => setIsMobile(window.innerWidth <= 768);
        checkIfMobile();
        window.addEventListener("resize", checkIfMobile);
        return () => window.removeEventListener("resize", checkIfMobile);
    }, []);

    useEffect(() => {
        if (!isMobile) {

            const handleMouseMove = (e: MouseEvent) => {
                const { innerWidth, innerHeight } = window;
                const x = (e.clientX - innerWidth / 2) / innerWidth;
                const y = (e.clientY - innerHeight / 2) / innerHeight;

                setTiltEffect({
                    rotateY: x * 80,
                    rotateX: y * -80,
                });
            };

            window.addEventListener("mousemove", handleMouseMove);
            return () => window.removeEventListener("mousemove", handleMouseMove);
        }
    }, [isMobile]);

    useEffect(() => {
        startAutoSlide();

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, []);

    const startAutoSlide = () => {
        if (intervalRef.current) clearInterval(intervalRef.current);

        intervalRef.current = setInterval(() => {
            handleImageChange();
        }, 8000);
    };

    const handleImageChange = () => {
        setIsFlipping(true);
        setFlipDirection((prev) => prev * -1);

        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 400);

        setTimeout(() => {
            setIsFlipping(false);
        }, 900);
    };

    const handleClick = () => {
        handleImageChange();
        startAutoSlide();
    };

    return (
        <section id="banner">
            <div className="container banner-container">
                <div className="banner-text">
                    <h1>Mostre para seus seguidores tudo o que você faz em um só lugar.</h1>
                    <a href="https://wa.me/5517991822859?text=Olá, gostaria de criar o meu link." className="botao-desktop cta-button">
                        ➝ Peça agora o seu link
                    </a>
                </div>
                <div className="carousel-container">
                    {isMobile ?
                        <div
                            className="carousel-image"
                            onClick={handleClick}
                            style={{
                                // transform: `rotateY(${flipDirection * 180}deg)`, // No mobile, só giramos horizontalmente
                                transition: "transform 1.2s cubic-bezier(0.3, 1, 0.3, 1.3), opacity 0.5s ease-in-out",
                                opacity: isFlipping ? 0.3 : 1,
                            }}
                        >
                            <img src={images[currentIndex].src} alt={images[currentIndex].alt} />
                        </div>
                        :
                        <div
                            className="carousel-image"
                            onClick={handleClick}
                            style={{
                                transform: `perspective(1000px) rotateX(${tiltEffect.rotateX}deg) rotateY(${tiltEffect.rotateY}deg) rotateY(${flipDirection * 180}deg)`,
                                transition: "transform 1.2s cubic-bezier(0.3, 1, 0.3, 1.3), opacity 0.5s ease-in-out",
                                opacity: isFlipping ? 0.3 : 1,
                            }}
                        >
                            <img src={images[currentIndex].src} alt={images[currentIndex].alt} />
                        </div>
                    }
                </div>
                <div className="planos-botao botao-mobile pb-5">
                    <a href="https://wa.me/5517991822859?text=Olá, gostaria de criar o meu link." className="cta-button">➝ Peça agora o seu link</a>
                </div>
            </div>
        </section>
    );
};

export default Carousel;
